module.exports = __webpack_public_path__ + "img/mercadolibre.e55fe6b7.jpeg";